import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

// Обычно ответ приходит быстрее: индикатор на долю секунды выглядел бы как мигание.
const SPINNER_DELAY_MS = 400;

/** Заставка до ответа о сессии. Фон — как у формы входа, чтобы смена экрана не бросалась в глаза. */
const SessionSplash = ({ unavailable = false }) => {
  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsSpinnerVisible(true), SPINNER_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      data-session-splash={unavailable ? 'unavailable' : 'checking'}
      className="flex min-h-screen flex-col items-center justify-center gap-3 bg-gray-50 p-4 dark:bg-gray-900"
    >
      {(isSpinnerVisible || unavailable) && (
        <Loader2 className="h-6 w-6 animate-spin text-gray-400" aria-hidden="true" />
      )}
      {unavailable && (
        <p role="status" className="text-center text-sm text-gray-600 dark:text-gray-400">
          Сервер недоступен, переподключаемся…
        </p>
      )}
    </div>
  );
};

export default SessionSplash;
